var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-table", {
    attrs: {
      data: _vm.data,
      bordered: true,
      paginated: _vm.data.length > _vm.perPage,
      "per-page": _vm.perPage
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(props) {
          return [
            _c(
              "sc-table-column",
              { attrs: { field: "id", label: "ID", sortable: "" } },
              [_vm._v("\n      " + _vm._s(props.row.id) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              { attrs: { field: "weight", label: "Peso", sortable: "" } },
              [_vm._v("\n      " + _vm._s(props.row.weight) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  field: "squared_weight",
                  label: "Peso cubado",
                  sortable: ""
                }
              },
              [_vm._v("\n      " + _vm._s(props.row.squared_weight) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  field: "selected_weight",
                  label: "Peso selecionado",
                  sortable: ""
                }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(props.row.selected_weight) + "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: {
                  field: "tracking_code",
                  label: "Código de rastreio",
                  sortable: ""
                }
              },
              [_vm._v("\n      " + _vm._s(props.row.tracking_code) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "sc-table-column",
              {
                attrs: { field: "dimensions", label: "Dimensões", sortable: "" }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.transformDimensions(props.row.dimensions)) +
                    "\n    "
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55aaaf3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55aaaf3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/components/ScPreInvoiceDetailVolumesTable.vue
// module id = null
// module chunks = 